import { render, staticRenderFns } from "./Form_rlzysczytjb.vue?vue&type=template&id=3c2982e7"
import script from "./Form_rlzysczytjb.vue?vue&type=script&lang=js"
export * from "./Form_rlzysczytjb.vue?vue&type=script&lang=js"
import style0 from "./Form_rlzysczytjb.vue?vue&type=style&index=0&id=3c2982e7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports